var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnverified3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 12,
    viewBox: "0 0 68 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23992_18999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6515 4.94217L46.4289 6.34858H48.827L48.5339 8.19892H46.1366L45.6136 11.4999H43.4277L44.7606 3.09131H49.5892L49.2943 4.94217H46.6515Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7061 11.4999H49.5205L50.8523 3.09131H53.0382L51.7061 11.4999Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5571 4.94217L56.3342 6.34858H58.7991L58.5068 8.19892H56.0417L55.8112 9.64798H58.4103L58.1175 11.4999H53.332L54.6649 3.09131H59.4483L59.1557 4.94217H56.5571Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5951 4.94217H63.1082C64.5129 4.94217 65.3716 5.79023 65.1321 7.29572C64.8744 8.93359 63.6453 9.64798 62.3408 9.64798H61.8503L62.5951 4.94217ZM59.3711 11.4999H62.4719C64.8013 11.4999 67.0326 9.66047 67.4082 7.29572C67.7829 4.93202 66.1443 3.09131 63.8021 3.09131H60.7026L59.3711 11.4999Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2946 4.94217L29.0725 6.34858H31.5366L31.2446 8.19892H28.7797L28.5495 9.64798H31.1494L30.855 11.4999H26.0703L27.4026 3.09131H32.1871L31.8942 4.94217H29.2946Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3708 4.75891H35.583C36.2969 4.75891 37.0792 4.89259 36.934 5.80696C36.79 6.72186 35.965 6.85527 35.2517 6.85527H35.0392L35.3708 4.75891ZM37.0136 8.04869C38.2411 7.83674 39.0471 6.83291 39.2299 5.67381C39.5142 3.87835 38.3792 3.08594 36.7179 3.08594H33.4494L32.1187 11.4948H34.3058L34.8166 8.2609H34.8389L36.3897 11.4948H39.1113L37.0136 8.04869Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8078 11.4999H39.6206L40.9532 3.09131H43.139L41.8078 11.4999Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.511 0.5L25.1869 2.56036L21.4167 8.6122L21.1686 6.07404L20.9741 3.31478H17.4971V3.70833C18.4972 3.70833 18.6306 4.00957 18.7952 4.98625L19.5523 11.42L19.557 11.4057L19.5671 11.5H22.2459L27.0333 2.32089L28.0388 0.5H26.511Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0386 3.25L15.7104 11.25H13.8979L11.7104 7.04687H11.6636L10.9604 11.25H8.78857L10.1167 3.25H11.9604L14.1167 7.4375H14.1792L14.8667 3.25H17.0386Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49282 3.25H8.78857L7.88844 8.47394C7.78384 9.09508 7.53885 9.6326 7.15347 10.0865C6.77084 10.5378 6.28361 10.8868 5.69178 11.1337C5.09995 11.3779 4.44205 11.5 3.71809 11.5C2.98862 11.5 2.37201 11.3779 1.86827 11.1337C1.36452 10.8868 0.998414 10.5378 0.769939 10.0865C0.544217 9.6326 0.483658 9.09508 0.588261 8.47394L1.4884 3.25H3.78415L2.91705 8.28282C2.87576 8.53499 2.89641 8.75929 2.97899 8.95572C3.06157 9.15215 3.19507 9.30743 3.37951 9.42157C3.56394 9.53306 3.78691 9.5888 4.04841 9.5888C4.31267 9.5888 4.55629 9.53306 4.77926 9.42157C5.00498 9.30743 5.19216 9.15215 5.34081 8.95572C5.48946 8.75929 5.58442 8.53499 5.62571 8.28282L6.49282 3.25Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2614 6.11591H22.4355L26.2199 0.5L19.668 2.18477V2.36232L22.2614 3.30795V6.11591Z",
    fill: "#FEF0C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23992_18999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.923,
    height: 11,
    fill: "white",
    transform: "translate(0.538574 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverified3);
export default __webpack_public_path__ + "static/media/unverified3.bc690741a803fa1c62e073b411188aae.svg";
export { ForwardRef as ReactComponent };